import { createContext, useContext, useEffect, useState } from "react";
import {
  getRedirectResult,
  GoogleAuthProvider,
  // onIdTokenChanged,
  signInWithCustomToken,
  // signInWithPopup,
  signInWithRedirect,
  signOut,
} from "firebase/auth";
import { FirebaseContext } from "../contexts";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const { auth, services } = useContext(FirebaseContext);
  const [googleCredentials, setGoogleCredentials] = useState(null);
  const [loadingCredentials, setLoadingCredentials] = useState(true);
  const [magicCredentials, setMagicCredentials] = useState(null);
  const sendMagicLink = async (email, returnUrl) => {
    return await services
      .sendEmailSignInLink({ email, returnUrl })
      .then((res) => ({ ok: true, data: res.data }))
      .catch((error) => ({ error }));
  };

  const signInWithGoogle = async () => {
    if (!googleCredentials) {
      const google = new GoogleAuthProvider().setCustomParameters({
        prompt: "select_account",
        hd: "stepuptutoring.org",
      });

      signInWithRedirect(auth, google);
      // const {user} = await signInWithPopup(auth, google);
      // const idToken = await user.getIdToken();
      // localStorage.setItem("idToken", idToken);
    }
  };

  const signInWithMagic = async (stepUpToken) => {
    const res = await services.getCustomAuthToken({ stepUpToken });
    return await signInWithCustomToken(auth, res.data.customToken)
      .then((credentials) => {
        setMagicCredentials(credentials.user);
        return { ok: true, data: credentials.user };
      })
      .catch((error) => ({ error }));
  };

  /**
   * Onboarding Portal Sign Out
   * **/
  const signOutFromMagic = async () => {
    return await signOut(auth)
      .then(() => {
        setMagicCredentials(null);
        return { ok: true };
      })
      .catch((error) => {
        return { error };
      });
  };

  /**
   * Tutor Portal Sign Out
   **/
  const signOutFromGoogle = async () => {
    return await signOut(auth)
      .then(() => {
        setGoogleCredentials(null);

        return { ok: true };
      })
      .catch((error) => {
        return { error };
      });
  };

  useEffect(() => {
    setLoadingCredentials(true);
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setGoogleCredentials(user);
        const idToken = await user.getIdToken();
        localStorage.setItem("idToken", idToken);
        setLoadingCredentials(false);
      } else {
        getRedirectResult(auth)
          .then(async (result) => {
            if (result?.user) {
              const user = result.user;
              setGoogleCredentials(user);
              const idToken = await user.getIdToken();
              localStorage.setItem("idToken", idToken);
            }
            setLoadingCredentials(false);
          })
          .catch((error) => {
            console.log("Redirect sign-in error:", error);
            setLoadingCredentials(false);
          });
      }
    });

    // onIdTokenChanged(auth, async (user) => {
    //   if (user) {
    //     const idToken = await user.getIdToken();
    //     localStorage.setItem("idToken", idToken);
    //   }
    // });
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider
      value={{
        googleCredentials,
        magicCredentials,
        sendMagicLink,
        loadingCredentials,
        setGoogleCredentials,
        signInWithGoogle,
        signInWithMagic,
        signOutFromGoogle,
        signOutFromMagic,
      }}>
      {children}
    </AuthContext.Provider>
  );
};
